import(/* webpackMode: "eager" */ "/private/tmp/statura-proddeploy-KTRC4o/apps/web/src/app/global-error.tsx");
